/**
 * @ngdoc directive
 * @name formcheckpassword
 *
 * @description
 * Page footer
 */
module.directive('formPassword', ['$compile', 'lodash', function ($compile, lodash) {
    'use strict';
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            model: '=ngModel',
            activeCheck: '@formPasswordStrength',
            requireCheck: '@formPasswordStrengthRequired',
            reference: '=formPasswordConfirm'
        },
        link: function ($scope, element, attr, controller) {
            // icon marker
            var icon = angular.element('<span ng-click="toggle()"></span>');
            icon.attr({
                class: 'password-icon'
            });
            $compile(icon)($scope);
            element.after(icon);

            // toggle password visibility
            $scope.show = false;
            $scope.toggle = function () {
                $scope.show = !$scope.show;
                element[0].type = element[0].type === 'text' ? 'password' : 'text';
            };

            // password strength
            var initStrength = function () {
                var requiredStrong = $scope.requireCheck === 'true';
                var bar = angular.element('<span></span>');
                bar.attr({
                    class: 'password-strength',
                    strength: 0
                });
                $compile(bar)($scope);
                icon.after(bar);

                controller.$validators.strong = function (value) {
                    var idx = 0;
                    if (value === '') {
                        bar.attr('strength', 0);
                        return true;
                    } else {
                        var s = $scope.mesureStrength(value);
                        if (s <= 10) { idx = 1; }
                        else if (s <= 20) { idx = 2; }
                        else if (s <= 30) { idx = 3; }
                        else if (s <= 40) { idx = 4; }
                        else { idx = 5; }
                        bar.attr('strength', idx);
                    }
                    return requiredStrong ? 5 === idx : idx ;
                }
            };
            if ($scope.activeCheck === 'true') {
                initStrength();
            }

            // strength password evaluator
            $scope.mesureStrength = function (p) {
                p = p || '';
                var _force = 0;
                var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                var _lowerLetters = /[a-z]+/.test(p);
                var _upperLetters = /[A-Z]+/.test(p);
                var _numbers = /[0-9]+/.test(p);
                var _symbols = _regex.test(p);

                var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                var  _passedMatches = lodash.filter(_flags, function (e) { return e === true; }).length;

                _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                _force += _passedMatches * 10;

                // penality (short password)
                _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                // penality (poor variety of characters)
                _force = (_passedMatches == 1) ? Math.min(_force, 10) : _force;
                _force = (_passedMatches == 2) ? Math.min(_force, 20) : _force;
                _force = (_passedMatches == 3) ? Math.min(_force, 40) : _force;

                return _force;
            };

            // compare to reference field
            if ($scope.reference !== undefined) {
                controller.$validators.confirmation = function (value) {
                    return value === $scope.reference;
                };

                $scope.$watch("reference", function () {
                    controller.$validate();
                });
            }
        }
    };
}]);
